import { useState } from 'react'
import type { FormEvent } from 'react'
import type { ClarifyOption, ClarifyQuestion } from './types'

interface Props {
  question: ClarifyQuestion
  onAnswer: (value: string, label: string) => void
  disabled?: boolean
}

export function ClarifyCard({ question, onAnswer, disabled }: Props) {
  const [text, setText] = useState('')
  const options = question.options || []

  const submitOption = (opt: ClarifyOption) => {
    if (disabled) return
    onAnswer(opt.value, opt.label)
  }

  const submitText = (e?: FormEvent) => {
    e?.preventDefault?.()
    if (disabled) return
    const v = text.trim()
    if (!v) return
    setText('')
    onAnswer(v, v)
  }

  return (
    <div className={`nw-clarify ${disabled ? 'is-disabled' : ''}`}>
      {question.header && <div className="nw-clarify-chip">{question.header}</div>}
      <div className="nw-clarify-text">{question.text}</div>

      {options.length > 0 && (
        <div className="nw-clarify-options">
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className="nw-clarify-option"
              onClick={() => submitOption(opt)}
              disabled={disabled}
              title={opt.description || ''}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}

      {question.allow_text && (
        <form className="nw-clarify-text-row" onSubmit={submitText}>
          <input
            className="nw-clarify-input"
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={options.length ? 'Other…' : 'Type your answer'}
            disabled={disabled}
          />
          <button
            type="submit"
            className="nw-clarify-submit"
            disabled={disabled || !text.trim()}
          >
            Send
          </button>
        </form>
      )}
    </div>
  )
}
